export type Environment = 'dev' | 'test' | 'qa' | 'prod';

const RECAPTCHA_KEYS_V3: Record<Environment, string> = {
  dev: '6LcTN8kqAAAAACxr0L7Sbps0EiB5HFlWo0apwedK',
  test: '6LcTN8kqAAAAACxr0L7Sbps0EiB5HFlWo0apwedK',
  qa: '6LcTN8kqAAAAACxr0L7Sbps0EiB5HFlWo0apwedK',
  prod: '6LcTN8kqAAAAACxr0L7Sbps0EiB5HFlWo0apwedK'
};

const OPTIMIZELY_KEYS: Record<Environment, string> = {
  dev: 'TBxEtKj6CKh2ExDUun3yr',
  test: 'RHzQi8eWfb817QRa7M8F4',
  qa: '7w9bG2YoCowyRaw3zPLW9',
  prod: 'QTBBrim4vGJgStNaAkgZN'
};

const PAULHOOD_PARTNER_URN: Record<Environment, string[]> = {
  dev: ['urn:lampo:sa_partner_id:10537'],
  test: ['urn:lampo:sa_partner_id:10537'],
  qa: ['urn:lampo:sa_partner_id:41927'],
  prod: ['urn:lampo:sa_partner_id:64005']
};

const KNAPPS_PARTNER_URN: Record<Environment, string[]> = {
  dev: ['urn:lampo:sa_partner_id:25046', 'urn:lampo:sa_partner_id:27733'],
  test: ['urn:lampo:sa_partner_id:25046', 'urn:lampo:sa_partner_id:27733'],
  qa: ['urn:lampo:sa_partner_id:25046', 'urn:lampo:sa_partner_id:54726'],
  prod: ['urn:lampo:sa_partner_id:50466']
};

const PRIME_PARTNER_URN: Record<Environment, string[]> = {
  dev: ['urn:lampo:sa_partner_id:26955'],
  test: ['urn:lampo:sa_partner_id:26955'],
  qa: ['urn:lampo:sa_partner_id:945'],
  prod: ['urn:lampo:sa_partner_id:63898']
};

export function environment(host = window.location.host): Environment | 'err' {
  if (/localhost|127\.0\.0\.1/.test(host)) {
    return 'dev';
  }
  if (/test\./.test(host)) {
    return 'test';
  }
  if (/qa\./.test(host)) {
    return 'qa';
  }
  if (/ramseysolutions\./.test(host)) {
    return 'prod';
  }

  return 'err';
}

export function recaptchaKeyV3(env = environment()): string {
  if (env === 'err') {
    return 'err';
  }

  return RECAPTCHA_KEYS_V3[env];
}

export function optimizelyKey(env = environment()): string {
  if (env === 'err') {
    return 'err';
  }

  return OPTIMIZELY_KEYS[env];
}

export function getNationalProQueryParam(
  partnerUrn: string,
  env = environment()
): string {
  if (env === 'err') {
    return '';
  }

  if (PAULHOOD_PARTNER_URN[env].includes(partnerUrn)) {
    return `national_pro=PAULHOOD`;
  } else if (KNAPPS_PARTNER_URN[env].includes(partnerUrn)) {
    return `national_pro=KNAPPS`;
  } else if (PRIME_PARTNER_URN[env].includes(partnerUrn)) {
    return `national_pro=PRIME`;
  }

  return '';
}
